// Video IDs for Google Drive embeds (shared across components)
export const videoFileIds = [
  { id: "1ne2VdOUdPkZVUtQxNmwdtJ4-Fh5rPlqN", title: "Property Video 1" },
  { id: "1cPyCwUpbP-njPWw2x5KMZU_N7Utj8iB6", title: "Property Video 2" },
  { id: "1nf1LqCp6F3SknXYDDnZMNjGgOvTouo4Q", title: "Property Video 3" },
  { id: "1RhHu87DjAWaIH5l3sLVYdiFOnBlx7EPY", title: "Property Video 4" },
  { id: "16bxnjdXNVccRfr4LBbakzDXcUm0v1HHU", title: "Property Video 5" },
  { id: "12AvExPkJh6c65v5X9heuZWRI0QkliVh6", title: "Property Video 6" }
];
